import { ApolloLink } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'

export const uploadLink: ApolloLink = createUploadLink({
  uri: import.meta.env.VITE_API,
})
